document.addEventListener('DOMContentLoaded', () => {
console.log("Dom Content Loaded");


// Start Playing with <a> Links in product pages description
$(".tablinks").on("click", function(){
console.log("Clicked");

$( ".tabs-content a" ).each(function( attr, text ) {
$(this).attr('rel', 'noreferrer noopener');
$(this).attr('target', '_blank');
});
  
console.log("<a> Product Links open in new window");
});  
// End Playing with <a> Links in product pages description

});             

   

// Cart % replace with other character Starts
window.onload = function changeText(){
console.log("Cart %"); 

function changeText(){  

$('.product-option dt').each(function() {
var text = $(this).html();
$(this).html(text.replace('%22', '"')); 
});

$('.bold_line_property').each(function() {
var text = $(this).html();
$(this).html(text.replace('%22', '"')); 
});  


}
setInterval(changeText, 500);
 
  
}

// Cart % replace with other character Ends




// Lazy Loader Stars

document.addEventListener("DOMContentLoaded", function() {
  var lazyloadImages;    

  if ("IntersectionObserver" in window) {
    lazyloadImages = document.querySelectorAll(".lazy");
    var imageObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var image = entry.target;
          image.src = image.dataset.src;
          image.classList.remove("lazy");
          imageObserver.unobserve(image);
        }
      });
    });

    lazyloadImages.forEach(function(image) {
      imageObserver.observe(image);
    });
  } else {  
    var lazyloadThrottleTimeout;
    lazyloadImages = document.querySelectorAll(".lazy");
    
    function lazyload () {
      if(lazyloadThrottleTimeout) {
        clearTimeout(lazyloadThrottleTimeout);
      }    

      lazyloadThrottleTimeout = setTimeout(function() {
        var scrollTop = window.pageYOffset;
        lazyloadImages.forEach(function(img) {
            if(img.offsetTop < (window.innerHeight + scrollTop)) {
              img.src = img.dataset.src;
              img.classList.remove('lazy');
            }
        });
        if(lazyloadImages.length == 0) { 
          document.removeEventListener("scroll", lazyload);
          window.removeEventListener("resize", lazyload);
          window.removeEventListener("orientationChange", lazyload);
        }
      }, 20);
    }

    document.addEventListener("scroll", lazyload);
    window.addEventListener("resize", lazyload);
    window.addEventListener("orientationChange", lazyload);
  }
})

// Lazy Loader Ends





//M8-Tabs
$(document).ready(function() {


var HeadActive = document.getElementsByClassName("tab-head")[0];
HeadActive.classList.add("active");

var TabActive = document.getElementsByClassName("tab-content")[0];
TabActive.classList.remove("hide");

var TabActive = document.getElementsByClassName("tab-content")[0];
TabActive.classList.add("active");


});
            
            


//M9-Accord
$(document).ready(function() {
  
var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");

  $(this).find(".accordionArrow").css("transform","rotate(90deg)");
   
   
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
      $(this).find(".accordionArrow").css("transform","rotate(0deg)");
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
      
    } 

    
  });
}


});



//Jq-Test

if (typeof jQuery === 'undefined') {
  console.log("jQuery is NOT available");
} else {
  console.log("jQuery is available 1");
}


jQuery(document).ready(function(){ 
console.log("jQuery is available 2"); 
}); 

$(document).ready(function(){ 
console.log("jQuery is available 3"); 
});




// if Faucet Styles Swatches are present on product page from app "SC Product Options fka Bold" then show popup

$(document).ready(function() {
 setTimeout(function() { 
 

$(".bold_option_value_swatch").mouseover(function(){
var GetInnerSpanIMG =  $(this).find("span").css( "background-image" );
GetInnerSpanIMG = GetInnerSpanIMG.replace(/^url\(["']?/, '').replace(/["']?\)$/, '');
document.getElementsByClassName("SwatchPopIMG")[0].src = GetInnerSpanIMG;
$(".SwatchPopDiv").css("display","none");
$(".SwatchPopMainDiv").css("display","grid");  
$(".SwatchPopDiv").css("display","flex");

  
})


 
$(".SwatchPopButton").click(function(){
  
$(".SwatchPopMainDiv").css("display","none");  
$(".SwatchPopDiv").css("display","none");

  
  
})

   
   
   
}, 1000);  
});


                  
